module.exports = __webpack_public_path__ + "img/7.19e4ddf.png";